import { VariableType } from 'json-to-graphql-query';

export const LoginVariables = { login: 'String!', password: 'String!' };
export const LoginArgs = { login: new VariableType('login'), password: new VariableType('password') };
